import { render, staticRenderFns } from "./RecordStatusWrap.vue?vue&type=template&id=37ae776f&lang=pug&"
import script from "./RecordStatusWrap.vue?vue&type=script&lang=js&"
export * from "./RecordStatusWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports